
import TC from '../../TC';
import Consts from '../Consts';
import MapInfo from './MapInfo';
import filter from '../filter';

TC.control = TC.control || {};
TC.Consts = Consts;
TC.control.MapInfo = MapInfo;
TC.filter = filter;

TC.control.Download = function (options) {
    var self = this;
    self._classSelector = '.' + self.CLASS;

    TC.Control.apply(self, arguments);

    self._hiddenElms = [];

    var opts = options || {};
    self._dialogDiv = TC.Util.getDiv(opts.dialogDiv);
    if (window.$) {
        self._$dialogDiv = $(self._dialogDiv);
    }
    if (!opts.dialogDiv) {
        document.body.appendChild(self._dialogDiv);
    }    
};

TC.inherit(TC.control.Download, TC.control.MapInfo);

(function () {
    var ctlProto = TC.control.Download.prototype;

    ctlProto.CLASS = 'tc-ctl-download';

    ctlProto.template = {};
    ctlProto.template[ctlProto.CLASS] = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, alias3=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {          return parent[propertyName];        }        return undefined    };  return "<h2>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"download",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":4},"end":{"line":1,"column":23}}}))    + " </h2>\r\n<div class=\"tc-ctl-tctr tc-ctl-tctr-select\">\r\n    <label class=\"tc-ctl-tctr-tab tc-ctl-download-image\" style=\"width:calc(100%/2 - 1px)\"><input type=\"radio\" name=\""    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"controlId") : depth0), depth0))    + "-sel\" value=\"image\" /><span>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"dl.export.map",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":3,"column":157},"end":{"line":3,"column":181}}}))    + "</span></label><label \r\n	class=\"tc-ctl-tctr-tab tc-ctl-download-data\" style=\"width:calc(100%/2 - 1px)\"><input type=\"radio\" name=\""    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"controlId") : depth0), depth0))    + "-sel\" value=\"data\" /><span>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"dl.export.vector",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":4,"column":145},"end":{"line":4,"column":172}}}))    + "</span></label>\r\n</div>\r\n<div class=\"tc-ctl tc-ctl-tctr-elm tc-ctl-tctr-elm-image tc-group tc-ctl-download-cnt tc-ctl-download-image tc-collapsed\">\r\n    <div>\r\n        <label>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"format",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":8,"column":15},"end":{"line":8,"column":32}}}))    + ":</label><select class=\"tc-combo\">\r\n            <option value=\"image/png\">PNG</option>\r\n            <option value=\"image/jpeg\">JPEG</option>\r\n        </select>\r\n        <div class=\"tc-ctl-download-div\">\r\n            <input id=\"tc-ctl-download-image-qr-"    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"controlId") : depth0), depth0))    + "\" class=\"tc-hidden\" type=\"checkbox\" checked />\r\n            <label for=\"tc-ctl-download-image-qr-"    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"controlId") : depth0), depth0))    + "\" class=\"tc-ctl-download-image-qr-label\" title=\""    + alias2(lookupProperty(helpers,"i18n").call(alias1,"createQrCodeToImage",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":14,"column":110},"end":{"line":14,"column":140}}}))    + "\">"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"appendQRCode",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":14,"column":142},"end":{"line":14,"column":165}}}))    + "</label>\r\n            <input id=\"tc-ctl-download-image-wld-"    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"controlId") : depth0), depth0))    + "\" class=\"tc-hidden\" type=\"checkbox\" />\r\n            <label for=\"tc-ctl-download-image-wld-"    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"controlId") : depth0), depth0))    + "\" class=\"tc-ctl-download-image-wld-label\" title=\""    + alias2(lookupProperty(helpers,"i18n").call(alias1,"appendWorldFile.explanation",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":16,"column":112},"end":{"line":16,"column":150}}}))    + "\">"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"appendWorldFile",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":16,"column":152},"end":{"line":16,"column":178}}}))    + "</label>\r\n        </div>\r\n\r\n        <div class=\"tc-group tc-group tc-ctl-download-cnt\" style=\"text-align:right;\">\r\n            <button type=\"button\" class=\"tc-ctl-download-btn tc-button tc-icon-button\" title=\""    + alias2(lookupProperty(helpers,"i18n").call(alias1,"downloadImageFromCurrentMap",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":20,"column":94},"end":{"line":20,"column":132}}}))    + "\" name=\"descargar\">"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"download",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":20,"column":151},"end":{"line":20,"column":170}}}))    + "</button>\r\n        </div>\r\n        <div class=\"tc-ctl-download-alert tc-alert alert-warning tc-hidden\">\r\n            <p>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"qrAdvice",true,{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":23,"column":15},"end":{"line":23,"column":39}}}))    + "</p>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"tc-ctl tc-ctl-tctr-elm tc-ctl-tctr-elm-data tc-group tc-ctl-download-cnt tc-collapsed\">\r\n    <div>\r\n        <label>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"format",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":29,"column":15},"end":{"line":29,"column":32}}}))    + ":</label><select class=\"tc-combo\">\r\n            <option value=\"GML32\">GML</option>\r\n            <option value=\"application/json\">GeoJSON</option>\r\n            <option value=\"application/vnd.google-earth.kml+xml\">KML (Google Earth)</option>\r\n            <option value=\"shape-zip\">Shapefile (ESRI)</option>\r\n        </select>\r\n\r\n        <div class=\"tc-ctl-download-div\">\r\n            <i class=\"tc-ctl-download-help icon-question-sign\" data-toggle=\"tooltip\" data-placement=\"top\" title=\""    + alias2(lookupProperty(helpers,"i18n").call(alias1,"showDownloadHelp",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":37,"column":113},"end":{"line":37,"column":140}}}))    + "\"></i>\r\n        </div>\r\n\r\n        <div class=\"tc-group tc-group tc-ctl-download-cnt\" style=\"text-align:right;\">\r\n            <button type=\"button\" class=\"tc-ctl-download-btn tc-button tc-icon-button\" title=\""    + alias2(lookupProperty(helpers,"i18n").call(alias1,"downloadLayersFromCurrentExtent",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":41,"column":94},"end":{"line":41,"column":136}}}))    + "\" name=\"descargar\">"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"download",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":41,"column":155},"end":{"line":41,"column":174}}}))    + "</button>\r\n        </div>\r\n\r\n        <div class=\"tc-alert alert-warning tc-hidden\">\r\n            <p id=\"zoom-msg-"    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"controlId") : depth0), depth0))    + "\"><strong>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"tooManyFeatures",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":45,"column":51},"end":{"line":45,"column":77}}}))    + ": </strong>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"tooManyFeatures.instructions",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":45,"column":88},"end":{"line":45,"column":127}}}))    + "</p>\r\n            <p id=\"layers-msg-"    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"controlId") : depth0), depth0))    + "\"><strong>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"noLayersLoaded",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":46,"column":53},"end":{"line":46,"column":78}}}))    + ": </strong>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"noLayersLoaded.instructions",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":46,"column":89},"end":{"line":46,"column":127}}}))    + "</p>\r\n            <p id=\"url-msg-"    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"controlId") : depth0), depth0))    + "\"><strong>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"tooManySelectedLayers",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":47,"column":50},"end":{"line":47,"column":82}}}))    + ": </strong>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"tooManySelectedLayers.instructions",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":47,"column":93},"end":{"line":47,"column":138}}}))    + "</p>\r\n            <p id=\"noFeatures-msg-"    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"controlId") : depth0), depth0))    + "\"><strong>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"noData",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":48,"column":57},"end":{"line":48,"column":74}}}))    + ": </strong>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"noData.instructions",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":48,"column":85},"end":{"line":48,"column":115}}}))    + "</p>\r\n            <p id=\"novalid-msg-"    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"controlId") : depth0), depth0))    + "\"><strong>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"noValidService",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":49,"column":54},"end":{"line":49,"column":79}}}))    + ": </strong>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"noValidService.instructions",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":49,"column":90},"end":{"line":49,"column":128}}}))    + "</p>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n";},"useData":true}
    ctlProto.template[ctlProto.CLASS + '-dialog'] = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {          return parent[propertyName];        }        return undefined    };  return "<div class=\"tc-ctl-download-help-dialog tc-modal\">\r\n    <div class=\"tc-modal-background tc-modal-close\"></div>\r\n    <div class=\"tc-modal-window\">\r\n        <div class=\"tc-modal-header\">\r\n            <h3>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"downloadData",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":5,"column":16},"end":{"line":5,"column":39}}}))    + "</h3>\r\n            <div class=\"tc-modal-close\"></div>\r\n        </div>\r\n        <div class=\"tc-modal-body\">\r\n            <p>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"dl.instructions.1",true,{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":9,"column":15},"end":{"line":9,"column":48}}}))    + "</p>\r\n            <ul>\r\n                <li>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"dl.instructions.2",true,{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":11,"column":20},"end":{"line":11,"column":53}}}))    + "</li>\r\n                <li>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"dl.instructions.3",true,{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":12,"column":20},"end":{"line":12,"column":53}}}))    + "</li>\r\n                    <li>\r\n                        "    + alias2(lookupProperty(helpers,"i18n").call(alias1,"dl.instructions.4",true,{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":14,"column":24},"end":{"line":14,"column":57}}}))    + "\r\n                    <ul>\r\n                        <li>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"dl.instructions.5",true,{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":16,"column":28},"end":{"line":16,"column":61}}}))    + "</li>\r\n                        <li>"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"dl.instructions.6",true,{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":17,"column":28},"end":{"line":17,"column":61}}}))    + "</li>\r\n                    </ul>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n        <div class=\"tc-modal-footer\">\r\n            <button type=\"button\" class=\"tc-button tc-modal-close\">"    + alias2(lookupProperty(helpers,"i18n").call(alias1,"close",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":23,"column":67},"end":{"line":23,"column":83}}}))    + "</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n";},"useData":true}

    ctlProto.render = function (callback) {
        const self = this;
        return self._set1stRenderPromise(self.getRenderedHtml(self.CLASS + '-dialog', null, function (html) {
            self._dialogDiv.innerHTML = html;
        }).then(function () {
            return TC.Control.prototype.renderData.call(self, { controlId: self.id }, function () {

                const cs = '.tc-ctl-tctr';
                self._selectors = {
                    TAB: cs + '-tab',
                    RADIOBUTTON: `input[type=radio][name="${self.id}-sel"]`,
                    ELEMENT: cs + '-elm'
                };

                const clickHandler = function (_e) {
                    var tab = this;
                    while (tab && !tab.matches(self._selectors.TAB)) {
                        tab = tab.parentElement;
                    }
                    if (tab) {
                        const checkbox = tab.querySelector(self._selectors.RADIOBUTTON);
                        const newValue = checkbox.value;
                        const elms = self.div.querySelectorAll(self._selectors.ELEMENT);
                        if (self._oldValue === newValue && self.options.deselectableTabs) {
                            setTimeout(function () {
                                checkbox.checked = false;
                            }, 0);
                            self._oldValue = null;
                            self._activeElm = null;
                            elms.forEach(function (elm) {
                                self._hiddenElms.push(elm);
                            });
                        }
                        else {
                            elms.forEach(function (elm) {
                                if (elm.matches(self._selectors.ELEMENT + '-' + newValue)) {
                                    self._activeElm = elm;
                                }
                                else {
                                    self._hiddenElms.push(elm);
                                }
                            });
                            self._oldValue = newValue;
                        }

                        self._hiddenElms.forEach(function (elm) {
                            elm.classList.add(TC.Consts.classes.COLLAPSED);
                        });
                        if (self._activeElm) {
                            self._activeElm.classList.remove(TC.Consts.classes.COLLAPSED);
                        }
                        checkbox.checked = true;
                    }
                };

                self.div.querySelectorAll('span').forEach(function (span) {
                    span.addEventListener(TC.Consts.event.CLICK, clickHandler, { passive: true });
                });
                if (callback) {
                    callback();
                }
            });
        }));
    };

    const toFixed = function (number) {
        let result = number.toFixed(20);
        if (result.indexOf('.') >= 0) {
            result = result.replace(/0+$/, '').replace(/\.$/, '');
        }
        return result;
    };

    ctlProto.register = function (map) {
        var self = this;
        const result = TC.control.MapInfo.prototype.register.call(self, map);

        // GLS: Añado el flag al mapa para tenerlo en cuenta cuando se establece la función de carga de imágenes
        self.map.crossOrigin = 'anonymous';

        const downLoadImage = function (format) {
            const li = self.map.getLoadingIndicator();
            const wait = li && li.addWait();
            const extent = self.map.getExtent();
            const doneQR = new Promise(function (resolve, _reject) {
                var canvases = self.map.wrap.getCanvas();
                var newCanvas = TC.Util.mergeCanvases(canvases);

                var sb = self.map.getControlsByClass(TC.control.ScaleBar);
                if (sb) {
                    self.drawScaleBarIntoCanvas({ canvas: newCanvas, fill: true });
                }

                if (!self._activeElm.querySelector(`#${self.CLASS}-image-qr-${self.id}:disabled`) && self._activeElm.querySelector(`#${self.CLASS}-image-qr-${self.id}:checked`)) {
                    const codeContainerId = 'qrcode';
                    var codeContainer = document.getElementById(codeContainerId);
                    if (codeContainer) {
                        codeContainer.innerHTML = '';
                    }
                    else {
                        codeContainer = document.createElement('div');
                        codeContainer.setAttribute('id', codeContainerId);
                        document.body.appendChild(codeContainer);
                    }

                    codeContainer.style.top = '-200px';
                    codeContainer.style.left = '-200px';
                    codeContainer.style.position = 'absolute';

                    self.makeQRCode(codeContainer, 87, 87).then(function (qrCodeBase64) {
                        if (qrCodeBase64) {
                            var ctx = newCanvas.getContext("2d");
                            ctx.fillStyle = "#ffffff";
                            ctx.fillRect(newCanvas.width - 91, newCanvas.height - 91, 91, 91);

                            TC.Util.addToCanvas(newCanvas, qrCodeBase64, { x: newCanvas.width - 88, y: newCanvas.height - 88 }).then(function (mapCanvas) {
                                resolve(mapCanvas);
                            });
                        } else {                            
                            li && li.removeWait(wait);
                        }
                    });
                } else {
                    resolve(newCanvas);
                }
            });

            doneQR.then(function (_canvas) {
                const fileName = window.location.hostname + '_' + self.map.crs.replace(':', '') + '_' + TC.Util.getFormattedDate(new Date().toString(), true);
                const fileExtension = '.' + format.split('/')[1];
                const worldFileExtension = format === TC.Consts.mimeType.JPEG ? '.jgw' : '.pgw';
                if (self._activeElm.querySelector(`#${self.CLASS}-image-wld-${self.id}:checked`)) {
                    TC.loadJS(!window.JSZip, TC.apiLocation + 'lib/jszip/jszip', function () {
                        const xScale = (extent[2] - extent[0]) / _canvas.width;
                        const ySkew = 0;
                        const xSkew = 0;
                        const yScale = (extent[1] - extent[3]) / _canvas.height;
                        const xOrigin = extent[0];
                        const yOrigin = extent[3];
                        const zip = new JSZip();
                        _canvas.toBlob(function (blob) {
                            zip.file(fileName + fileExtension, blob);
                            zip.file(fileName + worldFileExtension, `${toFixed(xScale)}
${ySkew.toFixed(1)}
${xSkew.toFixed(1)}
${toFixed(yScale)}
${toFixed(xOrigin)}
${toFixed(yOrigin)}`);
                            zip.generateAsync({ type: "blob" }).then(function (blob) {
                                TC.Util.downloadBlob(fileName + ".zip", blob);
                                li && li.removeWait(wait);
                            }, function (err) {
                                TC.error(self.getLocaleString('dl.export.map.error') + ': ' + err.message);
                                li && li.removeWait(wait);
                            });
                        }, format);
                    });
                }
                else {
                    try {
                        const res = _canvas.toDataURL(format);
                        TC.Util.downloadDataURI(fileName + fileExtension, format, res);
                    } catch (e) {
                        TC.error(self.getLocaleString('dl.export.map.error') + ': ' + e.message);
                    }
                    li && li.removeWait(wait);
                }
            });
        };


        /*
         * Descarga las features de las capas de trabajo actualmente seleccionadas. Comprueba que el número de features a descargar
         * no excede el límite impuesto por el servidor.
         */

        const downloadFeatures = function (format) {
            const li = self.map.getLoadingIndicator();
            const wait = li && li.addWait();

            const arrPromises = self.map.extractFeatures({
                filter: TC.filter.bbox(self.map.getExtent(), self.map.getCRS()),
                outputFormat: format,
                download: true
            });
            Promise.all(arrPromises).then(async function (responseArray) {

                var responses = responseArray.filter(item => !!item);
                if (responses.length === 0) {
                    _showAlertMsg({ key: TC.Consts.WFSErrors.NO_LAYERS }, wait);
                    return;
                }
                var arrDownloads = [];
                for (var i = 0; i < responses.length; i++) {
                    //errores del WFS
                    if (responses[i].errors && responses[i].errors.length) {
                        for (var j = 0; j < responses[i].errors.length; j++) {
                            var error = responses[i].errors[j];
                            _showAlertMsg(error, wait);
                        }
                        continue;
                    }
                    var data = responses[i].data;
                    var url = responses[i].url;
                    if (data && url)
                        arrDownloads.push({ url: url + "?download=zip", data: data });
                }
                try {
                    await TC.Util.downloadFileForm(arrDownloads);
                }
                catch (err) {
                    if (err.key === TC.Consts.DownloadError.MIMETYPE_NOT_SUPORTED) {
                        const service = responseArray.find(response => response.data === err.data).service;
                        const params = {
                            plural: service.layers.length > 1 ? self.getLocaleString("dl.format.notSupported.plural") : "",
                            layerNames: service.layers.reduce(function (vi, va, i, array) {
                                return (vi instanceof Array ? vi : [vi]).concat([va.title]).join(i < array.length - 1 ? ", " : " " + self.getLocaleString("dl.format.notSupported.conjunction") + " ");
                            }, []),
                            serviceTitle: service.mapLayers[0].title,
                            format: format
                        };
                        self.map.toast(self.getLocaleString("dl.format.notSupported").format(params), { type: TC.Consts.msgType.ERROR });
                    }
                }

                li && li.removeWait(wait);
            });
        };

        var _download = function () {
            var format = '';
            if (self._activeElm) {
                format = self._activeElm.querySelector('select').value;
            }
            if (format.indexOf('image') > -1) {
                downLoadImage(format);
            }
            else {
                downloadFeatures(format);
            }
        };

        var _showAlertMsg = function (error, wait) {
            const alert = self.div.querySelector('.alert-warning:not(.' + self.CLASS + '-alert)');
            var errorMsg;
            switch (error.key) {
                case TC.Consts.WFSErrors.MAX_NUM_FEATURES:
                    errorMsg = alert.querySelector("#zoom-msg-" + self.id).innerHTML.format({ serviceName: error.params.serviceTitle });
                    break;
                case TC.Consts.WFSErrors.NO_LAYERS:
                    errorMsg = self.getLocaleString('noLayersLoaded');
                    break;
                case TC.Consts.WFSErrors.GETCAPABILITIES:
                    errorMsg = alert.querySelector("#novalid-msg-" + self.id).innerHTML.format({ serviceName: error.params.serviceTitle });
                    break;
                case TC.Consts.WFSErrors.NO_FEATURES:
                    errorMsg = alert.querySelector("#noFeatures-msg-" + self.id).innerHTML;
                    break;
                case TC.Consts.WFSErrors.INDETERMINATE:
                    errorMsg = self.getLocaleString("wfs.IndeterminateError");
                    self.map.toast(errorMsg, { type: TC.Consts.msgType.ERROR });
                    TC.error("Error:{error} \r\n Descripcion:{descripcion} \r\n Servicio:{serviceName}".format({ error: error.params.err, descripcion: error.params.errorThrown, serviceName: error.params.serviceTitle }), TC.Consts.msgErrorMode.CONSOLE);
                    self.map.getLoadingIndicator().removeWait(wait);
                    return;
                default:
                    errorMsg = self.getLocaleString("wfs." + error.key, error.params);
                    break;
            }
            self.map.toast(errorMsg, { type: TC.Consts.msgType.WARNING });

            self.map.getLoadingIndicator().removeWait(wait);
        };

        var _showHelp = function (evt) {
            evt.stopPropagation();
            TC.Util.showModal(self._dialogDiv.querySelector(self._classSelector + '-help-dialog'));
        };

        self.div.addEventListener(TC.Consts.event.CLICK, TC.EventTarget.listenerBySelector('.tc-ctl-download-btn', _download), { passive: true });
        self.div.addEventListener(TC.Consts.event.CLICK, TC.EventTarget.listenerBySelector('.tc-ctl-download-help', _showHelp), { passive: true });

        self.div.addEventListener('change', TC.EventTarget.listenerBySelector(`#${self.CLASS}-image-qr-${self.id}`, function (e) {
            if (e.target.checked) {
                self.generateLink();
            } else {
                self.div.querySelector('.' + self.CLASS + '-alert').classList.add(TC.Consts.classes.HIDDEN);
            }
        }));

        self.div.addEventListener('click', TC.EventTarget.listenerBySelector('h2', function (evt) {            
            if (!self.registeredListeners) {
                self.generateLink();
            }
            self.registerListeners();
        }));

        return result;
    };

    ctlProto.manageMaxLengthExceed = function (maxLengthExceed) {
        const self = this;
        const alert = self.div.querySelector('.' + self.CLASS + '-alert');
        const checkboxQR = document.getElementById(`${self.CLASS}-image-qr-${self.id}`);

        checkboxQR.disabled = maxLengthExceed.qr;

        if (checkboxQR.checked) {
            alert.classList.toggle(TC.Consts.classes.HIDDEN, !maxLengthExceed.qr);
        } else {
            alert.classList.add(TC.Consts.classes.HIDDEN);
        }
    };

    ctlProto.generateLink = async function () {
        const self = this;
        const checkbox = self.div.querySelector(`.${self.CLASS}-div input[id|="${self.CLASS}-image-qr-download"]`);
        const label = self.div.querySelector(`label[for="${checkbox.id}"]`);
        checkbox.disabled = true;
        label.classList.add(TC.Consts.classes.LOADING);
        const result = await TC.control.MapInfo.prototype.generateLink.call(self);
        label.classList.remove(TC.Consts.classes.LOADING);
        return result;
    };

})();

const Download = TC.control.Download;
export default Download;